import { render, staticRenderFns } from "./LoginWithSSO.vue?vue&type=template&id=10b360f8&scoped=true&"
import script from "./LoginWithSSO.vue?vue&type=script&lang=js&"
export * from "./LoginWithSSO.vue?vue&type=script&lang=js&"
import style0 from "./LoginWithSSO.vue?vue&type=style&index=0&id=10b360f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b360f8",
  null
  
)

export default component.exports